import { render, staticRenderFns } from "./blockZkn.vue?vue&type=template&id=5caf3c55&scoped=true"
import script from "./blockZkn.vue?vue&type=script&lang=js"
export * from "./blockZkn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caf3c55",
  null
  
)

export default component.exports